export const isV2OrLater = () => {
	if (!process.env.GATSBY_DEPLOYMENT_VERSION) return true;
	if (Number(process.env.GATSBY_DEPLOYMENT_VERSION) >= 2) return true;
	return false;
};
